document.documentElement.classList.add('js');

const selectors = {
  drawer: '[data-drawer]',
  drawerOpen: '[data-drawer-open]',
  drawerClose: '[data-drawer-close]'
};
let lastFocusedElement = null;

function showToast(message) {
  const toast = document.querySelector('[data-toast]');
  if (!toast) return;
  toast.textContent = message;
  toast.hidden = false;
  window.clearTimeout(showToast.timeout);
  showToast.timeout = window.setTimeout(() => { toast.hidden = true; }, 3200);
}

function openDrawer(name) {
  const drawer = document.querySelector(`${selectors.drawer}[data-drawer="${name}"]`);
  if (!drawer) return;
  lastFocusedElement = document.activeElement;
  drawer.classList.add('is-open');
  drawer.setAttribute('aria-hidden', 'false');
  document.body.classList.add('drawer-open');
  document.querySelectorAll(`${selectors.drawerOpen}[data-drawer-open="${name}"]`).forEach((button) => button.setAttribute('aria-expanded', 'true'));
  drawer.querySelector('[data-drawer-close]')?.focus();
}

function closeDrawers() {
  document.querySelectorAll(`${selectors.drawer}.is-open`).forEach((drawer) => {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
  });
  document.body.classList.remove('drawer-open');
  document.querySelectorAll(selectors.drawerOpen).forEach((button) => button.setAttribute('aria-expanded', 'false'));
  lastFocusedElement?.focus();
}

document.querySelectorAll(selectors.drawerOpen).forEach((button) => {
  button.setAttribute('aria-expanded', 'false');
});

document.addEventListener('click', (event) => {
  const drawerButton = event.target.closest(selectors.drawerOpen);
  if (drawerButton) {
    event.preventDefault();
    openDrawer(drawerButton.dataset.drawerOpen);
    return;
  }

  if (event.target.closest(selectors.drawerClose)) {
    closeDrawers();
    return;
  }

  if (event.target.closest(`${selectors.drawer} a[href]`)) {
    closeDrawers();
    return;
  }

  const quantityButton = event.target.closest('[data-quantity-button]');
  if (quantityButton) {
    const wrapper = quantityButton.closest('[data-quantity]');
    const input = wrapper?.querySelector('input[type="number"]');
    if (!input) return;
    const direction = quantityButton.dataset.quantityButton;
    const next = direction === 'plus' ? Number(input.value) + 1 : Math.max(Number(input.min || 1), Number(input.value) - 1);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    closeDrawers();
    document.querySelectorAll('[data-mega-menu][open]').forEach((menu) => menu.removeAttribute('open'));
  }
  if (event.key === 'Tab') {
    const drawer = document.querySelector(`${selectors.drawer}.is-open`);
    if (!drawer) return;
    const focusable = [...drawer.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),summary')];
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  }
});

document.querySelectorAll('[data-announcement-close]').forEach((button) => {
  const bar = button.closest('[data-announcement]');
  const key = `announcement-${bar?.dataset.announcement}`;
  if (sessionStorage.getItem(key)) bar?.remove();
  button.addEventListener('click', () => {
    sessionStorage.setItem(key, 'dismissed');
    bar?.remove();
  });
});

document.querySelectorAll('[data-mega-menu]').forEach((menu) => {
  let closeTimer;
  const desktop = () => window.matchMedia('(min-width: 990px)').matches;
  const open = () => {
    if (!desktop()) return;
    window.clearTimeout(closeTimer);
    document.querySelectorAll('[data-mega-menu][open]').forEach((item) => {
      if (item !== menu) item.removeAttribute('open');
    });
    menu.setAttribute('open', '');
  };
  const close = () => {
    if (!desktop()) return;
    closeTimer = window.setTimeout(() => menu.removeAttribute('open'), 120);
  };
  menu.addEventListener('mouseenter', open);
  menu.addEventListener('mouseleave', close);
  menu.addEventListener('focusin', open);
  menu.addEventListener('focusout', (event) => {
    if (!menu.contains(event.relatedTarget)) close();
  });
});

document.querySelectorAll('[data-collection-tabs]').forEach((section) => {
  const tabs = [...section.querySelectorAll('[data-collection-tab]')];
  const panels = [...section.querySelectorAll('[data-collection-panel]')];
  if (!tabs.length) return;

  const activate = (tab, moveFocus = false) => {
    const target = tab.dataset.collectionTab;
    tabs.forEach((item) => {
      const active = item === tab;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-selected', String(active));
      item.tabIndex = active ? 0 : -1;
    });
    panels.forEach((panel) => {
      const active = panel.dataset.collectionPanel === target;
      panel.hidden = !active;
      panel.classList.toggle('is-active', active);
      if (active) panel.querySelectorAll('[data-reveal]').forEach((item) => item.classList.add('is-visible'));
    });
    if (moveFocus) tab.focus();
  };

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => activate(tab));
    tab.addEventListener('keydown', (event) => {
      let nextIndex;
      if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
      if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = tabs.length - 1;
      if (nextIndex === undefined) return;
      event.preventDefault();
      activate(tabs[nextIndex], true);
    });
  });
});

async function refreshCart(open = false) {
  const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart?sections=cart-drawer`);
  const sections = await response.json();
  const html = sections['cart-drawer'];
  if (!html) return;
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const replacement = doc.querySelector('#CartDrawerSection');
  const current = document.querySelector('#CartDrawerSection');
  if (replacement && current) current.replaceWith(replacement);
  const count = replacement?.dataset.cartCount || '0';
  document.querySelectorAll('.cart-count[data-cart-count]').forEach((node) => { node.textContent = count; });
  if (open) openDrawer('cart');
}

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('[data-quick-add]');
  if (!form) return;
  if (event.defaultPrevented) return;
  event.preventDefault();
  const button = form.querySelector('button[type="submit"]');
  const original = button?.textContent;
  let added = false;
  if (button) { button.disabled = true; button.textContent = 'Adding…'; }
  try {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || 'Unable to add this item.');
    openDrawer('cart');
    await refreshCart(true);
    added = true;
    if (button) {
      button.classList.add('is-added');
      button.textContent = 'Added ✓';
      window.setTimeout(() => {
        button.classList.remove('is-added');
        button.disabled = false;
        button.textContent = original;
      }, 1400);
    }
    showToast('Added to your cart.');
  } catch (error) {
    showToast(error.message);
  } finally {
    if (button && !added) { button.disabled = false; button.textContent = original; }
  }
});

document.addEventListener('change', async (event) => {
  const input = event.target.closest('[data-cart-line-quantity]');
  if (!input) return;
  try {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(input.dataset.line), quantity: Number(input.value) })
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || 'Unable to update the cart.');
    await refreshCart(false);
  } catch (error) { showToast(error.message); }
});

document.querySelectorAll('[data-product-root]').forEach((root) => {
  const data = root.querySelector('[data-product-json]');
  if (!data) return;
  const variants = JSON.parse(data.textContent);
  const selects = [...root.querySelectorAll('[data-option-select]')];
  const idInput = root.querySelector('[name="id"]');
  const price = root.querySelector('[data-product-price]');
  const compare = root.querySelector('[data-compare-price]');
  const button = root.querySelector('[data-add-to-cart]');
  const status = root.querySelector('[data-product-status]');
  const savingBadge = root.querySelector('[data-saving-badge]');

  const updateVariant = () => {
    const values = selects.map((select) => select.value);
    const variant = variants.find((item) => item.options.every((option, index) => option === values[index]));
    if (!variant) {
      button.disabled = true;
      button.textContent = 'Unavailable';
      status.textContent = 'This combination is unavailable.';
      return;
    }
    idInput.value = variant.id;
    price.textContent = variant.price;
    if (variant.compare_at_price) {
      compare.hidden = false;
      compare.textContent = variant.compare_at_price;
    } else compare.hidden = true;
    if (savingBadge) {
      const saving = variant.compare_at_price_raw > variant.price_raw
        ? Math.round(((variant.compare_at_price_raw - variant.price_raw) / variant.compare_at_price_raw) * 100)
        : 0;
      savingBadge.hidden = saving === 0;
      savingBadge.textContent = `Save ${saving}%`;
    }
    button.disabled = !variant.available;
    button.textContent = variant.available ? 'Add to cart' : 'Sold out';
    status.textContent = variant.available ? 'Available' : 'This selection is currently sold out.';
    if (variant.featured_media_id) root.querySelector(`[data-media-thumbnail="${variant.featured_media_id}"]`)?.click();
    if (history.replaceState) history.replaceState({}, '', `${location.pathname}?variant=${variant.id}`);
  };
  selects.forEach((select) => select.addEventListener('change', updateVariant));
});

document.querySelectorAll('[data-media-thumbnail]').forEach((button) => {
  button.addEventListener('click', () => {
    const gallery = button.closest('[data-product-gallery]');
    gallery.querySelectorAll('[data-media-thumbnail]').forEach((item) => item.classList.remove('is-active'));
    gallery.querySelectorAll('[data-media-thumbnail]').forEach((item) => item.setAttribute('aria-pressed', 'false'));
    gallery.querySelectorAll('[data-product-media]').forEach((item) => item.classList.remove('is-active'));
    button.classList.add('is-active');
    button.setAttribute('aria-pressed', 'true');
    gallery.querySelector(`[data-product-media="${button.dataset.mediaThumbnail}"]`)?.classList.add('is-active');
  });
});

document.querySelectorAll('[data-sort-by]').forEach((select) => select.addEventListener('change', () => select.form.submit()));

document.querySelectorAll('[data-product-recommendations]').forEach(async (container) => {
  if (!container.dataset.url) return;
  try {
    const response = await fetch(container.dataset.url);
    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const replacement = doc.querySelector('[data-product-recommendations]');
    if (replacement?.innerHTML.trim()) {
      replacement.querySelectorAll('[data-reveal]').forEach((item) => item.classList.add('is-visible'));
      container.replaceWith(replacement);
    }
  } catch (_) {
    // Recommendations are optional; product browsing remains fully functional.
  }
});

if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
    if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
  }), { rootMargin: '0px 0px -8% 0px' });
  document.querySelectorAll('[data-reveal]').forEach((element) => observer.observe(element));
} else {
  document.querySelectorAll('[data-reveal]').forEach((element) => element.classList.add('is-visible'));
}

document.addEventListener('shopify:section:load', () => location.reload());
